import React, { useEffect, useState } from 'react'
import TextContent from '../component/TextContent/TextContent'
import Footer from '../component/Footer/Footer'
import OurTeam from '../component/OurTeam/OurTeam'
import Header from '../component/Header/Header'
import ContactForm from '../component/ContactForm/ContactForm'
import ServiceContent from '../component/ServiceContent/ServiceContent'
import Contactform from '../component/Contact Form/Contactform'
import { Helmet } from 'react-helmet'

const ServicesList = [
  {
    id:"arthritic-conditions",
    img:"/images/creatives/service-content-2.png",
    heading:"Arthritic Conditions",
    shiftRow:false,
    paraList:[
      "Osteoarthritis","Rheumatoid Arthritis","Spinal Degeneration","and more"
    ],
    para:"If you have arthritic conditions like osteo and rheumatoid arthritis,  Laser Therapy will direct light at the area of pain and inflammation. It is non-invasive and will stimulate the body's natural healing processes. The cells absorb normalizing cellular function, reducing pain and enhancing the healing process."
    // para:"If you have arthritic conditions like osteo and rheumatoid arthritis,  Laser Therapy will direct light at the area of pain and inflammation. It is non-invasive with zero side effects and will stimulate the body's natural healing processes. The cells absorb the light producing new cells and revitalizing the body's natural healing process."
  },
  {
    id:"stress-injuries",
    img:"/images/creatives/service-content-3.png",
    heading:"Repetitive Strain Injuries",
    shiftRow:true,
    paraList:[
      "Carpal Tunnel Syndrome","Bursitis","Tennis/Golfers Elbow","Rotator Cuff Syndrome","Muscle Tightness","Patellar Tendonitis","Knee Strain","and  more.",
    ],
    para:"Laser therapy is an excellent choice for treating repetitive strain injuries, helping to reduce inflammation, pain, and promote tissue repair in affected areas like tendons and muscles that are commonly impacted by repetitive motions; making it an excellent treatment option for conditions like carpal tunnel syndrome or tendonitis."
  },
  {
    id:"sports-injuries",
    img:"/images/creatives/service-content-1.png",
    // heading:"Sports/Tissue Trauma",
    heading:"Sports Injuries/ Tissue Trauma",
    shiftRow:false,
    paraList:[
      "Ligament Sprains" ,"Tendon Tears" ,"Muscle Strains" ,"Tendonitis" ,"Contusions" ,"Achilles Tendinitis","and more."
    ],
    para:"Often a preferred choice by professional and recreational athletes, Laser Therapy helps them get back in the game faster after an injury or after surgery by reducing inflammation, stimulating collagen production and increasing blood supply to the injured area. Whether you are an athlete or not, the Bioflex Laser System is an excellent option for accident related injuries and tissue trauma."
  },
  {
    id:"wound-care",
    img:"/images/creatives/service-content-5.png",
    heading:"Wound Care",
    shiftRow:true,
    paraList:[
      "Laser Therapy can be administered to treat a number of wound types including: surgical incisions", 
      "burns", 
      "chronic ulcers", 
      "and pressure sores",
      "and  more.",
    ],
    para:"The Bioflex Laser System can be beneficial for wound healing as it stimulates cell regeneration and improves blood circulation to the affected area. The benefits include faster healing, pain relief, reduced inflammation and improved scar quality.",
    
    pdfLink:"/images/genral-problem-case.pdf"
  
  },
 
 
  {
    id:"genral-problems",
    img:"/images/creatives/service-content-4.png",
    heading:"General Problems",
    shiftRow:false,
    paraList:[
      "Joint Stiffness / Aches",
      "Post operative healing",
      "Trauma related injuries",
      "Cuts and bruises",
      "Motor vehicle accident related injuries",
      "Scar tissue",
      "Scar reduction",
      "Falls",
      "Chronic pain relief",
      "Wound Healing",
      "Neuropathy",
      "and  more.",
    ],
    para:"We have highlighted a few of the conditions typically treated with Laser Therapy however there are many more treatable conditions outlined in the list below. By bringing light, oxygen and blood flow to the affected area Laser Therapy can help with cell regeneration and collagen production to get you feeling great again.",
    reduceSpace:false,
  },
 
]

function Services() {
    const [bgImg,setBgImg]  = useState('/images/creatives/service-hero-bg.png')

    useEffect(()=>{
      if(window.innerWidth <= 992)
      {
        setBgImg("/images/creatives/service-hero-bg-mob.png")
      }
    },[])
  return (
    <div>
      <Helmet>
        <title>
        What We Treat | Laser Therapy for Sports Injuries & Arthritis
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://www.mobilelasertherapy.ca/what-we-treat"
        />
        <meta
          name="description"
          content="Mobile Laser Therapy treats sports injuries, tissue trauma, stress injuries, arthritic conditions, and general problems with non-invasive, drug-free laser therapy for pain relief, inflammation reduction, and faster healing."
        ></meta>
      </Helmet>
       
        <div style={{backgroundColor:"#F4FEFD"}}>
        <div style={{position:"relative",width:"100%"}}>
            <Header/>
        </div>
        </div>
        <div className='d-flex justify-content-center align-items-center' style={{position:"relative",zIndex:"-1",backgroundImage:`url('${bgImg}')`,backgroundRepeat:"no-repeat",backgroundSize:"cover",minHeight:"46vh",height:"auto"}}>
            {/* <img src={bgImg} alt='services page hero' style={{width:"100%"}}/> */}
            <div className='container '>
                <h3 className='hero-section-heading text-center' style={{color:'white',textShadow:"1px 0 white",textTransform:"uppercase"}}>WHAT WE TREAT</h3>
            </div>
        </div>

       
        {/* {
          ServicesList.map(ele =>{
            return(
              <ServiceContent
                heading={ele.heading}
                paraList={ele.paraList}
                img={ele.img}
                shiftRow={ele.shiftRow}
              />
            )
          })
        } */}

        {
          ServicesList.map((ele)=>{
            return(
              <div id={ele.id}>
                <TextContent
                    subHeading=""
                    subPara=""
                    heading= {ele.heading}
                    content={ele.para}
                    postHeading='Conditions:'
                    postContent={`${ele.paraList.join(", ")}`}
                    btnEndTel={true}
                    btnText="Book An Appointment"
                    btn={false}
                    btnRef='/contact'
                    shiftRow={ele.shiftRow}
                    img={ele.img}
                    reviewContent={false}
                    btnImg={false}
                    fontDark={true}
                    lineBetween={false}
                    txtAnchor={false}
                    reduceBottomSpace={ele.reduceSpace? ele.reduceSpace : true}
                    contentAlignStart={false}
                    pdfLink={ele?.pdfLink}
                />
              </div>
            )
          })
        }
 <div style={{backgroundColor:"white"}} className='py-4 pb-0'>
            <TextContent
                subHeading=""
                subPara=""
                heading= "The Clinical Conditions Typically Treated with Laser Therapy"
                content={"Laser therapy is a non invasive and drug free option that uses a healing bandwidth of light to stimulate the body's natural healing processes. At Mobile Laser Therapy, we specialize in treating a wide range of clinical conditions to help our clients experience pain relief, reduce inflammation, and promote faster recovery."}
                // content={"Laser therapy is a non invasive and drug free treatment option that uses focused light to stimulate the body's natural healing processes. At Mobile Laser Therapy, we specialize in treating a wide range of clinical conditions to help our clients experience pain relief, reduce inflammation, and promote faster recovery."}
                btn={false}
                btnEndTel={true}
                btnText="book an appointment"
                btnRef='/about'
                shiftRow={true}
                img="/images/creatives/service-text-1.png"
                reviewContent={false}
                btnImg={false}
                fontDark={true}
                lineBetween={false}
                txtAnchor={false}
                lazerPictureText={true}
                lazerContent={false}
            />
        </div>

        <div className='py-lg-0 py-4'></div>
       <Contactform/>
        <Footer 
        newsletterSection={false}
        />

    </div>
  )
}

export default Services